import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import CurrencyInput from "react-currency-input";
import { URLBunge } from "./Componentes/Config";
import {
  LogAcesso,
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoDescPesquisa,
  CampoFormCadastro,
  FormPesquisa,
  DescCampo,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  CampoFormBusca,
  ClienteProdutoSelecionado,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  BtCheckBox,
  EndLinha01,
  EndLinha02,
  EndLinha03,
  EndLinha04,
  SolicitanteCliente,
  ItemListaAtendimentos,
  TipoAtendimento,
} from "./Estilos";

import IcoBusca from "./Images/ico_search_branco.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFormularioEncaminhaRequisicao(props) {
  const history = useHistory();
  const location = useLocation();
  const [Loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();
  const [BtUrgencia, setBtUrgencia] = useState("");
  const [BtVerde, setBtVerde] = useState(false);
  const [BtAmarelo, setBtAmarelo] = useState(false);
  const [BtVermelho, setBtVermelho] = useState(false);
  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));
  const [TextoAguarde, setTextoAguarde] = useState(false);

  var idRequisicao = location.state.idRequisicao;
  var solicitante = location.state.solicitante;
  var cliente = location.state.cliente;
  var tipoAtendimento = location.state.tipoAtendimento;
  var detalhes = location.state.detalhes;
  var produto = location.state.produto;

  var dia = location.state.dataVisita.substr(8, 2);
  var mes = location.state.dataVisita.substr(5, 2);
  var ano = location.state.dataVisita.substr(0, 4);
  var hor = location.state.dataVisita.substr(11, 2);
  var min = location.state.dataVisita.substr(14, 2);

  var dataVisita = dia + "/" + mes + "/" + ano + " - " + hor + ":" + min;

  // var potencialCompra = (location.state.potencialCompra).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  var potencialCompra = location.state.potencialCompra + " KG";
  var cnpj = location.state.cnpj;
  var sap = location.state.sap;
  var rua = location.state.rua;
  var numero = location.state.numero;
  var cep = location.state.cep;
  var bairro = location.state.bairro;
  var cidade = location.state.cidade;
  var uf = location.state.uf;

  function PegaTecnicos() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/ListarTecnicos`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        for (let i = 0; i < result.listaTecnicos.length; i = i + 1) {
          setListaTecnicos((ListaTecnicos) => [
            ...ListaTecnicos,
            {
              value: result.listaTecnicos[i].id,
              label: result.listaTecnicos[i].nome,
            },
          ]);
        }
      })
      .catch((error) => console.log("error", error));
  }
  useEffect(() => {
    PegaTecnicos();
  }, []);
  const [ListaTecnicos, setListaTecnicos] = useState([]);

  function ValidaData(input) {
    var VerificaData =
      /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true;
    } else {
      return false;
    }
  }

  const EnviarFormulario = async (data, e) => {
    if (data.c_data == null || data.c_data == "") {
      AlertForm("Data é um campo obrigatório.");
      e.preventDefault();
      return false;
    }

    if (!ValidaData(data.c_data)) {
      AlertForm("Verifique a data");
      e.preventDefault();
      return false;
    }

    if (data.c_hora == null || data.c_hora == "") {
      AlertForm("Hora é um campo obrigatório.");
      e.preventDefault();
      return false;
    }

    if (data.c_tecnico == 0) {
      AlertForm("Você precisa selecionar um técnico");
      e.preventDefault();
      return false;
    }

    console.log("data", data);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      requisicaoId: idRequisicao,
      tecnicoId: data.c_tecnico,
      dataVisita:
        data.c_data.substr(6, 12) +
        "-" +
        data.c_data.substr(3, 2) +
        "-" +
        data.c_data.substr(0, 2) +
        "T" +
        data.c_hora.substr(0, 2) +
        ":" +
        data.c_hora.substr(3, 2) +
        ":00.000Z",
      prioridade: BtUrgencia,
    });

    console.log(raw);
    setTextoAguarde(true);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/EncaminharParaTecnico`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.sucesso === true) {
          setTextoAguarde(false);
          AlertRedirect(
            "Formulário encaminhado!",
            "AcademiaFormularioRequisicoes",
            history
          );
        } else {
          setTextoAguarde(false);
          AlertForm(result.mensagem);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setTextoAguarde(false);
      });
  };

  const MudaPrioridade = (escolha) => {
    setBtVerde(false);
    setBtAmarelo(false);
    setBtVermelho(false);
    switch (escolha) {
      case "Verde":
        setBtVerde(true);
        setBtUrgencia("Verde");
        break;
      case "Amarelo":
        setBtAmarelo(true);
        setBtUrgencia("Amarelo");
        break;
      case "Vermelho":
        setBtVermelho(true);
        setBtUrgencia("Vermelho");
        break;
    }
  };

  

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Encaminhar para o Técnico</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() =>
                history.push({
                  pathname: "/AcademiaFormularioRequisicoes",
                  state: {},
                })
              }
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>

            <FormPesquisa onSubmit={handleSubmit(EnviarFormulario)}>
              <ItemListaAtendimentos>
                <SolicitanteCliente>
                  {" "}
                  Solicitante: <div>{solicitante}</div>{" "}
                </SolicitanteCliente>
                <TipoAtendimento>
                  {" "}
                  Qual tipo de atendimento?{" "}
                  <div>
                    {tipoAtendimento}
                    <br />
                    {detalhes}
                  </div>{" "}
                </TipoAtendimento>
                <SolicitanteCliente>
                  Qual o cliente? <div>{cliente}</div>
                  CNPJ: {MascaraCNPJ(cnpj)}
                  <br />
                  SAP: {sap}
                  <br />
                  Endereço: {rua}, {numero}
                  <br />
                  {bairro}, {cidade}, {uf}
                  <br />
                  {cep}
                </SolicitanteCliente>

                <SolicitanteCliente>
                  {" "}
                  Qual o produto foco do atendimento? <div>{produto}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Qual a data que o cliente deseja a visita?{" "}
                  <div>{dataVisita}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Qual o potencial de compra/mês do cliente?{" "}
                  <div>{potencialCompra}</div>{" "}
                </SolicitanteCliente>
              </ItemListaAtendimentos>

              <DescCampo>Qual a data da visita?</DescCampo>
              <EndLinha04>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_data"
                    name="c_data"
                    type="text"
                    placeholder={"Data"}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="99/99/9999"
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_hora"
                    name="c_hora"
                    type="text"
                    placeholder={"Hora"}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask={"99:99"}
                  />
                </CampoFormCadastro>
              </EndLinha04>

              <CampoFormCadastro>
                <select name={"c_tecnico"} id={"c_tecnico"} ref={register}>
                  <option value={0} disabled selected>
                    Selecione
                  </option>
                  {ListaTecnicos.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <option value={item.value}>{item.label}</option>{" "}
                      </>
                    );
                  })}
                </select>
              </CampoFormCadastro>

              <br />

              <DescCampo>Urgência do atendimento:</DescCampo>
              <Button
                style={{
                  backgroundColor: BtVerde ? "green" : "#C2C2C2",
                  marginRight: 5,
                }}
                onClick={() => MudaPrioridade("Verde")}
              >
                sem urgência
              </Button>
              <Button
                style={{
                  backgroundColor: BtAmarelo ? "yellow" : "#c2c2c2",
                  marginRight: 5,
                }}
                onClick={() => MudaPrioridade("Amarelo")}
              >
                moderado
              </Button>
              <Button
                style={{ backgroundColor: BtVermelho ? "red" : "#c2c2c2" }}
                onClick={() => MudaPrioridade("Vermelho")}
              >
                crítico
              </Button>
              <br />
              <br />
              <Clear />
              {TextoAguarde === false ? (
                <BotaoEnviarPesquisa type="submit">
                  ENVIAR PARA O TÉCNICO
                </BotaoEnviarPesquisa>
              ) : (
                <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
              )}

              <Clear />
            </FormPesquisa>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default AcademiaFormularioEncaminhaRequisicao;
